import { reportUsage } from '@ms/yammer-telemetry';
import type { DeepLinkDetails } from '@ms/yammer-web-support/dist/teams/deeplinks/types';

export const reportDeepLinkUsageEvent = (deepLinkDetails: DeepLinkDetails): void => {
  const { entityId, entityType, correlationId, subType, type, notificationType } = deepLinkDetails;

  reportUsage({
    eventName: 'teams_deep_link_clicked',
    eventProperties: {
      deepLinkType: type,
      entityType,
      ...(type !== 'custom' && {
        deepLinkId: correlationId,
        deepLinkSubType: subType,
        ...(entityType !== 'user' && { entityId }),
      }),
      ...(notificationType && { notificationType }),
    },
  });
};
